import React from 'react';
import { stub } from '@xsk/frontend-skeleton';

export default class ProductMatch extends React.Component {

    render() {
        return(
            <stub.ui.ListPage
                module='cleanProductMatch'
                {...this.props}
                listMetadataKey='cleanData-productMatch-list'
                filterMetadataKey='cleanData-productMatch-filter'
            />
        )
    }

}
